<template>
    <div class="full-content" style="background-image:url('assets/img/bg-gaspol-1.jpg');">
        <div class="card bg-card-trans border-0 rounded-0 mobile-ver">
            <div class="mobile-ver-top mobile-ver-top-2">
                <div class="d-flex align-items-center h-100 justify-content-between px-3">
                    <div class="d-flex align-items-center">
                        <a href="javascript:void(0)" class="btn btn-white-naked btn-icon me-md-3 me-2"
                            v-on:click="goToPage('dashboard_student')">
                            <i class="fa-solid fa-arrow-left"></i>
                        </a>
                        <div class="d-block display-tektur h1 m-0">Promo TryOut</div>
                    </div>
                </div>
            </div>
            <div class="mobile-ver-content--has-simplebar mobile-ver-content-2 full-bottom">
                <div class="d-block px-md-4 px-3 pt-md-4 pt-3">
                    <div class="d-block mb-3">
                        <div class="card-body">
                            <div class="d-block text-center p-md-4">
                                <img src="assets/img/dashboard-icon-9.png" alt="Promo TO" width="140">
                                <div class="d-block text-center">
                                    <div class="d-block mb-2 display-tektur text-md">Fitur belum tersedia</div>
                                    <div class="d-block">Waduh, sepertinya fitur yang kamu cari masih disiapin. Tungguin
                                        ya, bakal ada kabar baik segera! ✨ 🚀</div>
                                    <!-- <div class="d-block">
                                            <a href="detail-alumni-siswa.php" class="btn btn-s-1 btn-primary">
                                                <div class="btn-s-1-inner">Kembali ke halaman utama</div>
                                            </a>
                                        </div> -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card mb-4">
                        <div class="card-body">
                            <div class="d-block p-md-4">
                                <div class="d-flex align-items-center mb-4">
                                    <i class="fa-solid fa-circle-question fa-2x text-pink flex-shrink-0 me-3"></i>
                                    <div class="d-block font-bold text-pink">Apa yang bakal ada di fitur ini?</div>
                                </div>
                                <div class="d-block">
                                    <p>Nanti di fitur ini kalian bakal dapet berbagai macam promo yang akan diberikan
                                        untuk paket tryout kalian. So, stay tune terus di Gaspol untuk ikuti ratusan
                                        promo yang menarik!</p>
                                </div>
                                <div class="d-block text-sm">
                                    <div class="d-flex align-items-center border-top pt-3 mt-3">
                                        <i class="fa-solid fa-check-circle flex-shrink-0 text-neon me-3"></i>
                                        <div class="d-block"><span class="font-bold">Pilihan Promo:</span> Berbagai
                                            macam jenis promo tryout yang dapat kalian ikuti dengan seru.</div>
                                    </div>
                                    <div class="d-flex align-items-center border-top pt-3 mt-3">
                                        <i class="fa-solid fa-check-circle flex-shrink-0 text-neon me-3"></i>
                                        <div class="d-block"><span class="font-bold">Paket Seru:</span> Ada juga paket
                                            seru yang diformulasikan oleh tim kita untuk keseruan paket tryout kalian.
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'StudentPromotion',
        methods: {
            goToPage: function (params = null) {
                this.$router.push({
                    name: params
                })
            }
        }
    }
</script>